module.exports = __webpack_public_path__ + "img/dark-half-moon-angle.5f7e9fe.svg";